<template>
  <div class="container" ref="container">
    <b-loading
      :is-full-page="true"
      v-model="isLoading"
      :can-cancel="true"
    ></b-loading>
    <b-notification
      :closable="false"
      v-if="this.errorMessage"
      type="is-danger"
      has-icon
      class="my-8"
      >{{ this.errorMessage }}</b-notification
    >
    <div class="columns employees">
      <div
        v-for="(department, index) in employees"
        :key="index"
        class="column is-fullwidth"
      >
        <h1 class="title">{{ department.department }}</h1>

        <div class="columns is-multiline is-mobile">
          <div
            v-for="(employee, innerIndex) in employees[0].employees"
            class="column is-one-third"
            :key="innerIndex"
          >
            <img
              v-if="employee.image"
              :src="employee.image"
              alt="Placeholder image"
            />
            <span v-else></span><br />
            {{ employee.name }}<br />
            {{ employee.position }}<br />

            <span class="contact-field">E-post:</span> {{ employee.email
            }}<br />
            <span class="contact-field">Tlf:</span> {{ employee.phone }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  data() {
    /*
    let employees = {
      1: {
        id: 1,
        name: "Stig Otto Nilsen",
        position: "Administrerende direktør",
        email: "stig@stadssalg.no",
        phone: "41458000",
        image: "https://bulma.io/images/placeholders/1280x960.png"
      },
      2: {
        id: 2,
        name: "Trine Nøvik",
        position: "Viseadministrerende direktør",
        email: "trine@stadssalg.no",
        phone: "95211609",
        image: "https://bulma.io/images/placeholders/1280x960.png"
      }
    };*/

    return {
      isLoading: false,
      errorMessage: false,
      employees: []
    };
  },

  mounted() {
    this.isLoading = true;

    this.$axios
      .get(`${window.apiURL}/employees`)
      .then(response => {
        this.isLoading = false;
        this.employees = this.lodashGroupBy(response.data);
      })
      .catch(error => {
        this.isLoading = false;
        this.errorMessage = error.response.data.message
          ? error.response.data.message
          : error.message;
      });
  },
  methods: {
    lodashGroupBy(department = null) {
      if (department) {
        return _(department)
          .groupBy("department")
          .map(function(employees, dep) {
            return {
              department: dep,
              employees: employees
            };
          })
          .value();
      }
    },
    groupBy(department = null) {
      if (department) {
        return this.employees
          .filter(employee => employee.department === department)
          .map(employee => employee);
      } else {
        console.log(this.employees.map(employee => employee.department));
        return this.employees.map(employee => employee.department);
      }
    }
  }
};
</script>

<style lang="scss">
.employees {
  .icon {
    vertical-align: text-bottom;
  }
}
</style>
